import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "display", "userHidden",
    "userSelect", "userFields",
    "anonymousSwitch", "anonymousFields", "moveToCartFields",
    "anonymousName", "anonymousEmail", "anonymousPhone", "anonymousInvite",
    "anonymousIdHidden", "anonymousNameHidden", "anonymousEmailHidden", "anonymousPhoneHidden", "anonymousInvitedHidden",
    "anonymousDestroyHidden"
  ]

  connect() {
    this.syncFromHidden()
    this.initTomSelect()
  }

  userSelectTargetConnected() {
    this.initTomSelect()
  }

  initTomSelect() {
    if (this.hasUserSelectTarget && !this.userSelectTarget.tomselect) {
      new TomSelect(this.userSelectTarget, {
        plugins: {
          remove_button: {
            title: 'Dieses Element entfernen',
          },
        },
      })
    }
  }

  syncFromHidden() {
    if (!this.hasAnonymousNameHiddenTarget) return

    const name = this.anonymousNameHiddenTarget.value || ''
    const email = this.hasAnonymousEmailHiddenTarget ? this.anonymousEmailHiddenTarget.value : ''
    const phone = this.hasAnonymousPhoneHiddenTarget ? this.anonymousPhoneHiddenTarget.value : ''
    const invited = this.hasAnonymousInvitedHiddenTarget && this.anonymousInvitedHiddenTarget.value === 'true'
    const isAnonymous = name.trim() !== ''

    if (this.hasAnonymousSwitchTarget) {
      this.anonymousSwitchTarget.checked = isAnonymous
    }

    if (this.hasUserFieldsTarget) {
      this.userFieldsTarget.classList.toggle('d-none', isAnonymous)
    }
    if (this.hasAnonymousFieldsTarget) {
      this.anonymousFieldsTarget.classList.toggle('d-none', !isAnonymous)
    }
    if (this.hasMoveToCartFieldsTarget) {
      this.moveToCartFieldsTarget.classList.toggle('d-none', isAnonymous)
    }

    if (this.hasAnonymousNameTarget) this.anonymousNameTarget.value = name
    if (this.hasAnonymousEmailTarget) this.anonymousEmailTarget.value = email
    if (this.hasAnonymousPhoneTarget) this.anonymousPhoneTarget.value = phone
    if (this.hasAnonymousInviteTarget) this.anonymousInviteTarget.checked = invited

    if (isAnonymous) {
      this.updateDisplay(name, true)
    }
  }

  toggleAnonymous(event) {
    const isAnonymous = event.target.checked

    if (this.hasUserFieldsTarget) {
      this.userFieldsTarget.classList.toggle('d-none', isAnonymous)
    }
    if (this.hasAnonymousFieldsTarget) {
      this.anonymousFieldsTarget.classList.toggle('d-none', !isAnonymous)
    }
    if (this.hasMoveToCartFieldsTarget) {
      this.moveToCartFieldsTarget.classList.toggle('d-none', isAnonymous)
    }
  }

  syncBeforeSubmit() {
    const isAnonymous = this.hasAnonymousSwitchTarget && this.anonymousSwitchTarget.checked

    if (isAnonymous) {
      const name = this.hasAnonymousNameTarget ? this.anonymousNameTarget.value : ''
      const email = this.hasAnonymousEmailTarget ? this.anonymousEmailTarget.value : ''
      const phone = this.hasAnonymousPhoneTarget ? this.anonymousPhoneTarget.value : ''
      const invite = this.hasAnonymousInviteTarget ? this.anonymousInviteTarget.checked : false

      if (this.hasAnonymousNameHiddenTarget) this.anonymousNameHiddenTarget.value = name
      if (this.hasAnonymousEmailHiddenTarget) this.anonymousEmailHiddenTarget.value = email
      if (this.hasAnonymousPhoneHiddenTarget) this.anonymousPhoneHiddenTarget.value = phone
      if (this.hasAnonymousInvitedHiddenTarget) this.anonymousInvitedHiddenTarget.value = invite ? 'true' : ''
      if (this.hasAnonymousDestroyHiddenTarget) this.anonymousDestroyHiddenTarget.value = ''

      this.updateDisplay(name, true)
    } else if (this.hasUserSelectTarget) {
      const selectedOption = this.userSelectTarget.options[this.userSelectTarget.selectedIndex]
      const userId = selectedOption.value
      const userName = selectedOption.dataset.name

      if (this.hasUserHiddenTarget) this.userHiddenTarget.value = userId

      if (this.hasAnonymousNameHiddenTarget) this.anonymousNameHiddenTarget.value = ''
      if (this.hasAnonymousEmailHiddenTarget) this.anonymousEmailHiddenTarget.value = ''
      if (this.hasAnonymousPhoneHiddenTarget) this.anonymousPhoneHiddenTarget.value = ''
      if (this.hasAnonymousInvitedHiddenTarget) this.anonymousInvitedHiddenTarget.value = ''
      if (this.hasAnonymousDestroyHiddenTarget) this.anonymousDestroyHiddenTarget.value = '1'

      this.updateDisplay(userName, false)
    }
  }

  updateDisplay(name, isAnonymous) {
    if (!this.hasDisplayTarget) return

    if (isAnonymous) {
      this.displayTarget.innerHTML = `<strong>${name} <span class="badge bg-secondary">Anonym</span></strong>`
    } else {
      this.displayTarget.innerHTML = `<strong>${name}</strong>`
    }
  }
}
